import { provideHooks } from 'redial';
import { connect } from 'react-redux';
import { feedColumns } from '../../service/tickercolumns';
import {
    requestCurrenciesData,
    updateCurrency,
    newCurrencies,
    fetchCurrencies,
    changeCurrenciesFilters,
    loadingCurrencies,
} from '../../actions/currencies';
import { requestTickerData } from '../../actions/ticker';
import { getDeviceBreakpoint } from '../../service/device';
import CurrenciesPage from '../../components/pages/CurrenciesPage';
import withTableSubscription from '../../hoc/withTableSubscription';
import withPageTitle from '../../hoc/withPageTitle';

const hooks = {
    fetch: ({ dispatch }) => Promise.all([
        dispatch(requestCurrenciesData()),
        dispatch(requestTickerData('X:SUSDSEK.IDCFX', feedColumns)),
    ]),
};

const sources = [
    'feed.omni.index.CURRENCIES_SEK_RT',
    'feed.omni.index.CURRENCIES_SEK_EOD',
];

function mapStateToProps({ currencies, device }) {
    return {
        ...currencies,
        title: 'currency',
        sources,
        columns: feedColumns,
        breakpoint: getDeviceBreakpoint(device.windowWidth),
    };
}

const mapDispatchToProps = {
    update: updateCurrency,
    create: newCurrencies,
    fetch: fetchCurrencies,
    changeFilters: changeCurrenciesFilters,
    loadingCurrencies,
};

export default provideHooks(hooks)(
    connect(mapStateToProps, mapDispatchToProps)(
        withTableSubscription(
            withPageTitle(CurrenciesPage)
        )
    )
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/CurrenciesPage.js
 **/